<div class="hdma-grid" [formGroup]="formGroup">
  <div class="hdma-header">
    <h5 class="hdma-title">HDMA Information</h5>
  </div>
  <div class="hdma-field">
    <div class="user-record-field-wrapper">
      <label for="hdmaFirstName" class="field-label">First Name</label>
      <mat-form-field class="school-fields">
        <input id="hdmaFirstName"
               matInput
               type="text"
               placeholder="First Name"
               class="user-record-field-input"
               formControlName="hdmaFirstName"
               [value]="hdmaFirstName" />
        @if (formGroup.get('hdmaFirstName')?.invalid && formGroup.get('hdmaFirstName')?.touched) {
          @if (formGroup.get('hdmaFirstName')?.hasError('required')) {
            <mat-error>First Name is required</mat-error>
          } @else if (formGroup.get('hdmaFirstName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('hdmaFirstName')?.getError('name')?.message ?? 'First Name format is invalid' }}</mat-error>
          } @else {
            <mat-error>First Name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="hdma-field">
    <div class="user-record-field-wrapper">
      <label for="hdmaLastName" class="field-label">Last Name</label>
      <mat-form-field class="school-fields">
        <input id="hdmaLastName"
               matInput
               type="text"
               placeholder="Last Name"
               class="user-record-field-input"
               formControlName="hdmaLastName"
               [value]="hdmaLastName" />
        @if (formGroup.get('hdmaLastName')?.invalid && formGroup.get('hdmaLastName')?.touched) {
          @if (formGroup.get('hdmaLastName')?.hasError('required')) {
            <mat-error>Last Name is required</mat-error>
          } @else if (formGroup.get('hdmaLastName')?.hasError('name')) {
            <mat-error>{{ formGroup.get('hdmaLastName')?.getError('name')?.message ?? 'Last Name format is invalid' }}</mat-error>
          } @else {
            <mat-error>Last Name is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
  <div class="hdma-field">
    <div class="user-record-field-wrapper">
      <label for="hdmaEmail" class="field-label">Email Address</label>
      <mat-form-field class="school-fields">
        <input id="hdmaEmail"
               matInput
               disabled
               type="email"
               placeholder="hdma@example.com"
               class="user-record-field-input"
               [value]="schoolData.hdmaEmail ?? schoolData.email ?? ''" />
      </mat-form-field>
    </div>
  </div>
  <div class="hdma-field">
    <div class="phone-ext-row">
      <div class="user-record-field-wrapper phone-ext-row__phone">
        <label for="phone" class="field-label">Phone Number</label>
        <mat-form-field class="school-fields">
          <input id="phone"
                 matInput
                 type="text"
                 [mask]="'(000) 000-0000'"
                 formControlName="schoolPhone"
                 placeholder="(123) 456-7890"
                 class="user-record-field-input"
                 [dropSpecialCharacters]="false" />
          @if (formGroup.get('schoolPhone')?.invalid && formGroup.get('schoolPhone')?.touched) {
          <mat-error>Phone Number is required</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="user-record-field-wrapper phone-ext-row__ext">
        <label for="schoolPhoneExt" class="field-label">Ext. Number</label>
        <mat-form-field class="school-fields">
          <input id="schoolPhoneExt"
                 matInput
                 type="text"
                 maxlength="4"
                 inputmode="numeric"
                 placeholder="1234"
                 class="user-record-field-input"
                 formControlName="schoolPhoneExt"
                 (input)="onExtensionInput($event)" />
        </mat-form-field>
      </div>
    </div>
  </div>
  <div class="hdma-field">
    <div class="user-record-field-wrapper">
      <label for="backgroundCheckValidationDate" class="field-label">
        Background Check Validated
      </label>
      <mat-form-field class="school-fields">
        <div class="user-record-datepicker-wrapper">
          <input id="backgroundCheckValidationDate"
                 matInput
                 [matDatepicker]="bgCheckPicker"
                 placeholder="MM/DD/YYYY"
                 class="user-record-field-input"
                 formControlName="backgroundCheckValidationDate" 
                 readonly
                 (click)="bgCheckPicker.open()"/>
          <mat-datepicker-toggle matIconSuffix [for]="bgCheckPicker"></mat-datepicker-toggle>
          <mat-datepicker #bgCheckPicker></mat-datepicker>
        </div>
        @if (formGroup.get('backgroundCheckValidationDate')?.invalid &&
        formGroup.get('backgroundCheckValidationDate')?.touched) {
          @if (formGroup.get('backgroundCheckValidationDate')?.hasError('required')) {
            <mat-error>Background Check Validation Date is required</mat-error>
          } @else if (formGroup.get('backgroundCheckValidationDate')?.hasError('futureDate')) {
            <mat-error>Background Check Validation Date must be in the past</mat-error>
          } @else {
            <mat-error>Background Check Validation Date is invalid</mat-error>
          }
        }
      </mat-form-field>
    </div>
  </div>
</div>
